import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import TriggersEmpty from "../components/TriggersEmpty";

export default function SMSTriggersTable(props) {
  const { smsTriggers, onEdit, onDelete, showActions } = props;

  if (smsTriggers.length === 0) {
    return <TriggersEmpty />;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Event</TableHeader>
          <TableHeader>Phone Number</TableHeader>
          {showActions && <TableHeader>Action</TableHeader>}
        </TableRow>
      </TableHead>
      <TableBody>
        {smsTriggers.map((item, index) => (
          <TableRow key={index}>
            <TableCell className="whitespace-normal">
              {item.actionName}
            </TableCell>
            <TableCell>
              {item.phoneNumber === ""
                ? "Identified from call"
                : item.phoneNumber}
            </TableCell>

            {showActions && (
              <TableCell className="">
                <div className="flex flex-row gap-x-2">
                  <Button
                    outline
                    onClick={() => onEdit({ isOpen: true, item, index })}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    outline
                    onClick={() => onDelete({ isOpen: true, item, index })}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
